import { useEffect, useState } from "react";
import api from "../api/api";

function Newspapers() {
  const [papers,      setPapers]      = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [paymentMode,  setPaymentMode]  = useState({});
  const [loading,      setLoading]      = useState(true);
  const [subscribing] = useState(false);

  useEffect(() => {
    api.get("/user/newspapers")
      .then(res => setPapers(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPapers([]))
      .finally(() => setLoading(false));
  }, []);

//   const subscribe = async (paperId) => {
//     const billingType = selectedPlan[paperId];
//     if (!billingType) { alert("Please select a plan first"); return; }

//     setSubscribing(prev => ({ ...prev, [paperId]: true }));
//     try {
//       await api.post("/user/subscribe", {
//         newspaperId: paperId,
//         billingType,
//         paymentMode: paymentMode[paperId] || null,
//       });
//       alert("Subscription successful! 🎉");
//       window.location.reload();
//     } catch (err) {

//   const msg =
//     err.response?.data?.message ||
//     err.response?.data ||
//     "Subscription failed";

//   alert(msg);

// } finally {
//       setSubscribing(prev => ({ ...prev, [paperId]: false }));
//     }
//   };

const subscribe = async (paperId) => {

  const billingType = selectedPlan[paperId];
  if (!billingType) {
    alert("Select plan");
    return;
  }

  // 🟢 DAILY → direct subscribe
  if (billingType === "DAILY") {
    await api.post("/user/subscribe", {
      newspaperId: paperId,
      billingType,
      paymentMode: null
    });

    alert("Subscribed successfully ✅");
    window.location.reload();
    return;
  }

  // 🔥 MONTHLY → use Razorpay
  try {

    // 1️⃣ Create order
    const res = await api.post(`/payment/create-order-for-subscription`, {
      newspaperId: paperId
    });

    const { orderId, amount } = res.data;

    const options = {
  key: "rzp_test_SX7vqmXKyQThaD",
  amount: amount * 100,
  currency: "INR",
  name: "PressManager",
  description: "Monthly Subscription",
  order_id: orderId,

  handler: async function (response) {

    await api.post("/payment/verify-subscription", {
      newspaperId: paperId,
      orderId,
      paymentId: response.razorpay_payment_id,
      signature: response.razorpay_signature
    });

    alert("Subscription activated 🎉");
    window.location.reload();
  },

  // 🔥 ADD THIS (IMPORTANT FIX)
 method: {
  upi: (paymentMode[paperId] || "UPI") === "UPI",
  card: (paymentMode[paperId] || "UPI") === "CARD",
  netbanking: false,
  wallet: false,
  emi: false,
  paylater: false
}
};

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    alert("Payment failed ❌");
  }
};

  if (loading) return <p className="text-muted fs-13">Loading newspapers…</p>;

  if (papers.length === 0) return (
    <div className="empty-state">
      <div className="empty-icon">📰</div>
      <div className="empty-title">No newspapers available</div>
      <div className="empty-sub">Check back later</div>
    </div>
  );

  return (
    <div>
      <div className="section-hdr mb-24">
        <div className="section-hdr-title">Available Newspapers</div>
        <span className="badge badge-muted">{papers.length} papers</span>
      </div>

      <div className="paper-grid">
        {papers.map(p => (
          <div className="paper-card" key={p.newspaperId}>
            <div className="paper-card-top">
              <div>
                <div className="paper-card-name">{p.name}</div>
                <div className="paper-card-lang">{p.language || "General"}</div>
              </div>
              <span style={{ fontSize: 26 }}>📰</span>
            </div>

            <div className="paper-card-body">
              <div className="price-row">
                <span className="price-lbl">Daily Rate</span>
                <span className="price-val">₹{p.dailyPrice}/day</span>
              </div>
              <div className="price-row">
                <span className="price-lbl">Monthly Package</span>
                <span className="price-val">₹{p.monthlyPrice}/mo</span>
              </div>

              {/* Plan selector */}
              <div style={{ marginTop: 14 }}>
                <div style={{ display: "flex", gap: 14, marginBottom: 10 }}>
                  {["DAILY", "MONTHLY"].map(plan => (
                    <label key={plan} style={{
                      display: "flex", alignItems: "center", gap: 6,
                      cursor: "pointer", fontSize: 13,
                    }}>
                      <input
                        type="radio"
                        name={`plan-${p.newspaperId}`}
                        checked={selectedPlan[p.newspaperId] === plan}
                        onChange={() =>
                          setSelectedPlan(prev => ({ ...prev, [p.newspaperId]: plan }))
                        }
                      />
                      <span style={{ fontWeight: 500 }}>
                        {plan === "DAILY" ? "Daily" : "Monthly"}
                      </span>
                    </label>
                  ))}
                </div>

                {selectedPlan[p.newspaperId] === "MONTHLY" && (
                  <div>
                    <p style={{
                      fontSize: 12, color: "var(--sage)", fontWeight: 600,
                      marginBottom: 8
                    }}>
                      Pay ₹{p.monthlyPrice} upfront
                    </p>
                    <select
                      className="form-select"
                      value={paymentMode[p.newspaperId] || "UPI"}
                      onChange={e =>
                        setPaymentMode(prev => ({ ...prev, [p.newspaperId]: e.target.value }))
                      }
                    >
                      {["UPI", "CARD", "CASH", "WALLET"].map(m =>
                        <option key={m} value={m}>{m}</option>
                      )}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="paper-card-foot">
              <button
                className={`btn btn-block ${selectedPlan[p.newspaperId] === "MONTHLY" ? "btn-gold" : "btn-primary"}`}
                onClick={() => subscribe(p.newspaperId)}
                disabled={subscribing[p.newspaperId] || !selectedPlan[p.newspaperId]}
              >
                {subscribing[p.newspaperId]
                  ? "Processing…"
                  : selectedPlan[p.newspaperId] === "MONTHLY"
                  ? "💳 Pay & Subscribe"
                  : "Subscribe"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Newspapers;
